





import { Vue, Component, Prop } from 'vue-property-decorator'
import '../assets/octicons/index.scss'

import '../assets/octicons/svg/key.svg'
import '../assets/octicons/svg/search.svg'
import '../assets/octicons/svg/arrow-right.svg'
import '../assets/octicons/svg/arrow-left.svg'
import '../assets/octicons/svg/package.svg'
import '../assets/octicons/svg/shield.svg'
import '../assets/octicons/svg/eye.svg'
import '../assets/octicons/svg/clippy.svg'
import '../assets/octicons/svg/mark-github.svg'

@Component
export default class SvgIcon extends Vue {
    @Prop(String) private name!: string
}
